import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"; // Import PDF icon
import ImageIcon from "@mui/icons-material/Image"; // Import image icon

import EmptyFolder from "../EmptyFolder";
import Menu from "@mui/material/Menu";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import IconButton from "@mui/material/IconButton";

import { useAppContext } from "../AppContext";
import CopyLinkMenuItems from "./CopyLinkMenuItems";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import DownloadMenuItems from "./DownloadMenuItems";
import RenameMenuItems from "./RenameMenuItems";
import DeleteItem from "./DeleteItem";

import { DataGrid } from "@mui/x-data-grid";
import { formatDate } from "app/utils/date";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}
function formatBytes(bytes) {
    if (!bytes) {
        return "---";
    }
    if (bytes < 1024) {
        return bytes + " Bytes";
    } else if (bytes < 1024 * 1024) {
        return (bytes / 1024).toFixed(2) + " KB";
    } else if (bytes < 1024 * 1024 * 1024) {
        return (bytes / (1024 * 1024)).toFixed(2) + " MB";
    } else {
        return (bytes / (1024 * 1024 * 1024)).toFixed(2) + " GB";
    }
}

function getFileExtension(fileName) {
    if (fileName) {
        return fileName.split(".").pop().toLowerCase();
    } else {
        return null;
    }
}

function getFileIcon(fileExtension) {
    switch (fileExtension?.toLowerCase()) {
        case "pdf":
            return <PictureAsPdfIcon style={{ marginRight: 8, color: "#d93025" }} />;
        case "jpg":
        case "jpeg":
        case "png":
            return <ImageIcon style={{ marginRight: 8, color: "#d93025" }} />;
        // case "doc":
        // case "docx":
        //     return  <FontAwesomeIcon icon={faFileExcel} />
        // case "xlsx":
        //     return <XlxsIcon style={{ marginRight: 8, color: "#d93025" }} />;
        // case "zip":
        //     return <ZipIcon style={{ marginRight: 8, color: "#d93025" }} />;
        // case "txt":
        //     return <TxtIcon style={{ marginRight: 8, color: "#d93025" }} />;
        default:
            return <InsertDriveFileIcon style={{ marginRight: 8, color: "#d93025" }} />;
    }
}

function MainContentArea({ folderContents, fetchFolderContents, handleDownload, clickDownload, setShowIcons, confirmDelete, handleDelete }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [contextMenuOpen, setContextMenuOpen] = useState(false);
    const [contextMenuPosition, setContextMenuPosition] = useState({ top: 0, left: 0 });
    const [hoveredRow, setHoveredRow] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [isSnackbarError, setIsSnackbarError] = useState(false);
    const appData = useAppContext();
    const [checked, setChecked] = useState({});
    // const [sortedFolderContents, setSortedFolderContents] = useState(folderContents);
    const [sortDirections, setSortDirections] = useState({});
    const [selectedItems, setSelectedItems] = useState([]);
    const [actionStatus,setActionStatus] = useState(false);

    const handleSnackbarClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setSnackbarOpen(false);
    };

    const showSnackbar = (message, isError) => {
        setSnackbarMessage(message);
        setIsSnackbarError(isError);
        setSnackbarOpen(true);
    };

    const handleRowClick = (item, e) => {
        
        const { type, folderId } = item.row;

        // if (e.target.type === "checkbox") {
        //     setChecked({ ...checked, [e.target.id]: e.target.checked });
        // } else {
            if (type === "folder") {
                const currentPath = location.pathname;
                let newPath = "";
                if (currentPath.includes("/shared/hash")) {
                    newPath = `${currentPath}/${folderId}`;
                    navigate(newPath, { replace: true });
                } else {
                    newPath = `${currentPath}/${folderId}`;
                    navigate(newPath);
                }
            }

            // if (type === "file") {
            //     handleContextMenu(e, item.row);
            // }
        // }
    };

    const handleContextMenu = (event, item) => {
        event.preventDefault();
        setContextMenuOpen(true);
        setContextMenuPosition({ top: event.clientY, left: event.clientX });
        setSelectedItem(item); // Set the selected item
    };

    const handleCloseContextMenu = () => {

     
            setContextMenuOpen(false);
        
        
    };
    const handleMenuItemClick = async action => {};

    const handleRowHover = (folderId, isHovered) => {
        setHoveredRow(isHovered ? folderId : null);
    };
    const getItemId = item => (item.type === "folder" ? item.folderId : item.fileId);

    // let sortedFolderContents=folderContents;

    const handleSelectionModelChange = selectionModel => {
        // 'selectionModel' contains an array of selected row IDs
        setSelectedItems(selectionModel);
    };

    useEffect(() => {
        if (clickDownload) {
            // let selectedIds = Object.keys(checked).filter(key => checked[key] === true);
            handleDownload(selectedItems);
        }

        if (confirmDelete) {
            // let selectedIds = Object.keys(checked).filter(key => checked[key] === true);
            handleDelete(selectedItems);
        }

        // let selectedCheckBoxes = Object.keys(selectedItems).filter(key => checked[key] === true);

        if (selectedItems.length === 0) {
            setShowIcons(false);
        } else {
            setShowIcons(true);
        }
    }, [selectedItems, clickDownload, confirmDelete]);

    // const HoverableTableCell = ({ value, children }) => {
    //     const [isHovered, setIsHovered] = useState(false);

    //     const handleClick = e => {
    //         e.preventDefault();
    //         setIsHovered(true);

    //         let filterColumn = e.currentTarget.value;

    //         setSortDirections(prevState => ({
    //             ...prevState,
    //             [filterColumn]: !prevState[filterColumn]
    //         }));

    //         let sortedContents = [...folderContents].sort((a, b) => {
    //             let aValue, bValue;

    //             if (filterColumn === "fileName") {
    //                 aValue = a.fileName ? a.fileName : a.folderName;
    //                 bValue = b.fileName ? b.fileName : b.folderName;
    //             } else if (filterColumn === "fileSize") {
    //                 aValue = a.fileSize !== undefined ? Number(a.fileSize) : Number.MAX_SAFE_INTEGER;
    //                 bValue = b.fileSize !== undefined ? Number(b.fileSize) : Number.MAX_SAFE_INTEGER;
    //             } else if (filterColumn === "modifiedDate") {
    //                 aValue = a.modifiedDate ? new Date(a.modifiedDate) : new Date(8640000000000000);
    //                 bValue = b.modifiedDate ? new Date(b.modifiedDate) : new Date(8640000000000000);
    //             } else {
    //                 aValue = a[filterColumn];
    //                 bValue = b[filterColumn];
    //             }

    //             if (aValue < bValue) {
    //                 return sortDirections[filterColumn] ? 1 : -1;
    //             } else if (aValue > bValue) {
    //                 return sortDirections[filterColumn] ? -1 : 1;
    //             } else {
    //                 return 0;
    //             }
    //         });

    //         setSortedFolderContents(sortedContents);
    //     };

    //     const handleMouseEnter = () => {
    //         setIsHovered(true);
    //     };

    //     const handleMouseLeave = e => {
    //         setIsHovered(false);
    //     };

    //     return (
    //         <TableCell onMouseEnter={handleMouseEnter} onMouseLeave={e => handleMouseLeave(e)}>
    //             {children}
    //             {isHovered && (
    //                 <IconButton style={{ padding: 0 }} value={value} onClick={e => handleClick(e)}>
    //                     {sortDirections[value] ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
    //                 </IconButton>
    //             )}
    //         </TableCell>
    //     );
    // };

    const columns = [
        { field: "id", headerName: "",flex:0.1,sortable:false,filterable:false},
        {
            field: "type",
            headerName: "",
            sortable:false,filterable:false,
            flex: 0.05,
            renderCell: params => (params.row.fileName ? getFileIcon(getFileExtension(params.row.fileName)) : <FolderOpenOutlinedIcon />)
        },
        {
            field: "name",
            headerName: "Name",
            flex: 2,
            resizable: true,
            renderCell: (params) => (
                <div style={{ 
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    overflow:"hidden"
                }}>
                    {params.row.fileName ? params.row.fileName : params.row.folderName}
                </div>
            )
        },
        {
            field: "actions",
            headerName: "",
            width:0,
            sortable:false,filterable:false,
            renderCell: params => (
                <IconButton
                    onClick={event => {
                        event.stopPropagation(); // Prevent event propagation
                        handleContextMenu(event, params.row);
                    }}
                >
                    {" "}
                    <MoreVertOutlinedIcon style={{ color: "rgb(103, 103, 115)" }} />
                </IconButton>
            )
        },
        {
            field: "modifiedDate",
            headerName: "Modified Date",
            flex: 1,
            resizable: true,
            renderCell: params => (params.row.modifiedDate ? formatDate(params.row.modifiedDate) : "")
        },
        { field: "owner", headerName: "Owner", flex: 1, sortable: location.pathname.includes("shared") || location.pathname.includes("workspace") && true, renderCell: params => `${params.row.user.first_name} ${params.row.user.last_name}` },

        {
            field: "size",
            headerName: "Size",
            flex: 1,
            resizable: true,
            renderCell: params => formatBytes(params.row.fileSize)
        },
        
    ];

    const transformedFolderContents = folderContents.map(item => ({
        ...item,
        name: item.fileName ? item.fileName : item.folderName,
        modifiedDate: item.modifiedDate? new Date(item.modifiedDate) : null,
        owner:`${item.user.first_name} ${item.user.last_name}`,
        size : item.fileSize  ? Number(item.fileSize) : null
    }));

    return (
        <>
            {!transformedFolderContents || transformedFolderContents.length <= 0 ? (
                <EmptyFolder />
            ) : (
                <>
                    <DataGrid
                        sx={{
                            '.MuiDataGrid-iconButtonContainer': {
                                visibility: 'visible',
                            },
                            '.MuiDataGrid-sortIcon': {
                                opacity: 'inherit !important',
                            },
                            ".MuiTablePagination-displayedRows": {
                                "margin-top": "1em",
                                "margin-bottom": "1em",
                            },
                            ".MuiTablePagination-selectLabel":{
                                "margin-top": "1em",
                                "margin-bottom": "1em",
                            },
                            '& .MuiDataGrid-cell:focus': {
                                outline: 'none',
                            },
                            '& .MuiDataGrid-columnHeader:focus': {
                                outline: 'none',
                            },
                            '& .MuiDataGrid-columnHeader:focus-within': {
                                outline: 'none',
                            }
                        }}
                        getRowHeight={() => 'auto'}
                        rows={transformedFolderContents}
                        columns={columns}
                        getRowId={row => row.fileId ? `file-${row.fileId}` : `folder-${row.folderId}`}
                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 10 }
                            }
                        }}
                        pageSizeOptions={[10,25,50]}
                        checkboxSelection
                        onRowSelectionModelChange={handleSelectionModelChange}
                        onRowClick={handleRowClick}
                        disableColumnMenu
                        slotProps={{
                            row: {
                                onContextMenu: e => {
                                    let [type, id] = e.currentTarget.getAttribute("data-id").split("-");
                                    id = Number(id);

                                    const row = transformedFolderContents.find(row => (type === "file") ? (row.fileId === id) : (row.folderId === id));

                                    handleContextMenu(e, row);
                                },
                                style: {cursor: "pointer"}
                            }
                        }}
                    />

                    {/* <TableContainer component={Paper} style={{ marginTop: "20px" }}>
                        <Table>
                            <TableHead>
                                <TableRow style={{ whiteSpace: "nowrap" }}>
                                    <TableCell></TableCell>
                                    <HoverableTableCell value="fileName">Name</HoverableTableCell>
                                    <TableCell></TableCell>
                                    <HoverableTableCell value="modifiedDate">Modified</HoverableTableCell>
                                    <HoverableTableCell value="user.first_name">Owner</HoverableTableCell>
                                    <HoverableTableCell value="fileSize">Size</HoverableTableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {sortedFolderContents?.length > 0 &&
                                    sortedFolderContents.map(item => (
                                        <TableRow
                                            key={item.folderId || item.fileId}
                                            onClick={e => handleRowClick(e, item)} //item.type, item.folderId
                                            onContextMenu={e => handleContextMenu(e, item)}
                                            style={{
                                                cursor: "pointer",
                                                backgroundColor: hoveredRow === getItemId(item) ? "#f2f2f2" : "inherit"
                                            }}
                                            onMouseEnter={() => handleRowHover(getItemId(item), true)}
                                            onMouseLeave={() => handleRowHover(getItemId(item), false)}
                                        >
                                            <TableCell>
                                                <Checkbox id={item.folderId ? "folder-" + item.folderId : "file-" + item.fileId} checked={checked[item.folderId] || checked[item.fileId]} />
                                            </TableCell>
                                            <TableCell>
                                                {item.type === "folder" ? <FolderOpenOutlinedIcon style={{ marginRight: 8, color: "#676773" }} /> : getFileIcon(getFileExtension(item.fileName))}
                                                {item.folderName || item.fileName}
                                            </TableCell>
                                            <TableCell>
                                                <IconButton
                                                    onClick={event => {
                                                        event.stopPropagation(); // Prevent event propagation
                                                        handleContextMenu(event, item);
                                                    }}
                                                >
                                                    {" "}
                                                    <MoreVertOutlinedIcon style={{ color: "rgb(103, 103, 115)" }} />
                                                </IconButton>
                                            </TableCell>
                                            <TableCell>{item.modifiedDate && formatDate(item.modifiedDate)}</TableCell>
                                            <TableCell>{`${item.user.first_name} ${item.user.last_name}`}</TableCell>
                                            <TableCell>{item.fileSize ? formatBytes(item.fileSize) : "-"}</TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer> */}

                    {/* Context Menu */}
                    <Menu anchorReference="anchorPosition" anchorPosition={{ top: contextMenuPosition.top, left: contextMenuPosition.left }} open={contextMenuOpen} onClose={!actionStatus? handleCloseContextMenu : ()=>{}} >
                        {/* <MenuItem onClick={() => handleMenuItemClick('Share')} >
                <ShareOutlinedIcon fontSize="small" style={{ marginRight: 8 }} /> Share
              </MenuItem> */}
                    {/* <Box height={20} />
                   { !actionStatus && <IconButton
                            aria-label="close"
                            onClick={handleCloseContextMenu}
                            sx={{
                            position: 'absolute',
                            right: 0,
                            top: 0,
                            cursor:"pointer"
                            }}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>} */}

                        {}
                        <>
                            <DownloadMenuItems selectedItem={selectedItem} handleCloseContextMenu={handleCloseContextMenu} showSnackbar={showSnackbar} setActionStatus={setActionStatus}/>

                            {!location.pathname.includes("shared") && (
                                <>
                                    <CopyLinkMenuItems selectedItem={selectedItem} handleCloseContextMenu={handleCloseContextMenu} showSnackbar={showSnackbar} />
                                    <RenameMenuItems selectedItem={selectedItem} handleCloseContextMenu={handleCloseContextMenu} showSnackbar={showSnackbar} fetchFolderContents={fetchFolderContents} />
                                    <DeleteItem selectedItem={selectedItem} handleCloseContextMenu={handleCloseContextMenu} showSnackbar={showSnackbar} fetchFolderContents={fetchFolderContents} setActionStatus={setActionStatus}/>
                                </>
                            )}
                        </>
                    </Menu>
                    <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
                        <div>
                            <Alert style={{ background: isSnackbarError ? "red" : "#383a87" }} onClose={handleSnackbarClose} severity={isSnackbarError ? "error" : "success"}>
                                {snackbarMessage}
                            </Alert>
                        </div>
                    </Snackbar>
                </>
            )}
        </>
    );
}

// import * as React from 'react';
// import { DataGrid } from '@mui/x-data-grid';

// const columns = [
//   {field: 'checkbox', headerName: ''},
//   { field: 'fileName', headerName: 'Name'},
//   { field: 'modifiedDate', headerName: 'Modified Date'},
//   { field: 'user.first_name', headerName: 'Owner' },
//   {
//     field: 'fileSize',
//     headerName: 'Size',
//   }
// ];

// const rows = [
//   { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
//   { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
//   { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
//   { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
//   { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
//   { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
//   { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
//   { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
//   { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
// ];

// export default function DataTable() {
//   return (
//     <div style={{ height: 400, width: '100%' }}>
//       <DataGrid
//         rows={rows}
//         columns={columns}
//         initialState={{
//           pagination: {
//             paginationModel: { page: 0, pageSize: 5 },
//           },
//         }}
//         pageSizeOptions={[5, 10]}
//         checkboxSelection
//       />
//     </div>
//   );
// }

export default MainContentArea;
